module.exports = __webpack_public_path__ + "static/img/核心优势_bj_image@2x.7bd5560c.jpg";